<template>
    <section class="data-page">
        <div class="row  justify-content-center mt-5 mt-5" >
          <div class="col-sm-12">
             <form   class="" >
            <div   class="form-content p-4">
              <h4 class="text-center">Phone verification</h4>
              <p class="text-center" v-if="otp==false"><span class="text-danger">*</span>To keep your transactions secure, please verify the M-Pesa phone number you’ll use for this activity.<span class="text-danger">*</span></p>


              <div class="row justify-content-center">
                <div class="col-sm-12">
              <div class="form-group mb-2" v-if="otp==false">
                <label>Enter Mpesa Phone no.<span class="text-danger">*</span></label>
                <input type="text" class="form-input"  v-model="message.phone"  required>
              </div>
                   <div class="form-group" v-else>
  <p class="text-center"><span class="text-danger">*</span>A five digits verification code has been sent to <strong>{{ message.phone }}</strong>.Please enter to verify.<span class="text-danger">*</span></p>

  <div class="otp-row" role="group" aria-label="5 digit one-time passcode">
    <input v-for="(digit, index) in otpFields"
           :key="index"
           type="text"
           inputmode="numeric"
           pattern="[0-9]*"
           maxlength="1"
           class="otp"
           v-model="otpFields[index]"
           @input="updatePassword(index)"
           @keydown.backspace="handleBackspace(index, $event)"
           ref="otpInputs" />
  </div>
</div>



              <div class="text-center mt-3" v-if="otp==false"><button v-on:click="getPasswordOtp()" type="button" class="btn btn-success btn-block" :disabled="loading" >
                <span v-if="!loading">
                Verify Now  <i class="fa fa-arrow-right ms-1"></i>
              </span>
              <span v-else class="spinner-border spinner-border-sm text-light" role="status"></span>
            </button>
          </div>
                 <div v-else class="text-center mt-3"><button v-on:click="verifyOTP()" type="button" class="btn btn-success btn-block" :disabled="loading" ve>
                <span v-if="!loading">
                Confirm OTP  <i class="fa fa-arrow-right ms-1"></i>
              </span>
              <span v-else class="spinner-border spinner-border-sm text-light" role="status"></span>
            </button>
          </div>
          <a href="#" v-on:click="getPasswordOtp()" class="mt-5" v-if="otp==true">Resend OTP</a>


              </div>
                     <div class="container text-center mt-5">
    <a href="https://play.google.com/store/apps/details?id=io.ionic.airtimetocash" target="_blank">
        <img
            src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
            alt="Get it on Google Play"
            style="width:100px;height:auto;opacity: 0.7;">
    </a>
</div>


              </div>
              </div>

                </form>


          </div>
        </div>
</section>
</template>
<script>
    // import moment from 'moment'
    export default {
        name: 'Index',
        components: {

        },
        data(){
            return {
                message:{},
                loading: false,
                  otpFields: ['', '', '', '',''],
                  otp:false

            }
        },
        created(){
          this.getIp();
        },
        methods: {
          getPasswordOtp(){
           this.loading = true;
              let uri=`/api/auth/getPasswordOtp`;
            this.$axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
               this.loading = false;
                if(response.data.status){
                  this.otp=true;

                }else{
                  this.$swal({icon: 'warning',title: 'Request Failed',text: response.data.message});

                }
            }).catch(error => {
                this.loading = false;
                this.$swal({icon: 'warning',title: 'Error',text: 'We are not able to complete your request.'});
            });
          },
                verifyOTP(){
           this.loading = true;
              let uri=`/api/auth/verifyOTP`;
            this.$axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
               this.loading = false;
                if(response.data.status){
                           localStorage.setItem('token', response.data.access_token);
                            localStorage.setItem('name', response.data.user.name);
                            localStorage.setItem('auth', 'yes');
                            this.$router.push({name: 'purchase'});
                }else{
                  this.$swal({icon: 'warning',title: 'Request Failed',text: response.data.message});

                }
            }).catch(error => {
                this.loading = false;
                this.$swal({icon: 'warning',title: 'Error',text: 'We are not able to complete your request.'});
            });
          },
                    getIp(){
                let uri =`https://api.ipify.org/?format=json`;
                this.$axios.get(uri).then((response) => {
                  this.message.ip_address=response.data.ip;
                  this.message.os=window.navigator.platform;
                }).catch(error => {

                });
          },
          updatePassword(index) {
      // Move to next input automatically
      if (this.otpFields[index] && index < this.otpFields.length - 1) {
        this.$refs.otpInputs[index + 1].focus();
      }
      // Join digits into one string
      this.message.otp = this.otpFields.join('');
    },
    handleBackspace(index, event) {
      if (!this.otpFields[index] && index > 0) {
        this.$refs.otpInputs[index - 1].focus();
      }
    }
        },
    }

</script>



// WEBPACK FOOTER //
// src/components/auth.vue